module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popover-box",
    class: {
      'istopiclist': _vm.istopiclist === 1
    }
  }, [_c('div', {
    staticClass: "p-b-inner"
  }, [_c('div', {
    staticClass: "p-b-i-top"
  }, [_vm._v("\n      " + _vm._s(_vm.popoverContent) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "p-b-i-bottom"
  }, [_c('div', {
    staticClass: "p-b-i-b-ensure openappAndroidwx wx-launch-app-btn-parent"
  }, [_vm._v("\n        确定\n      ")]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        _vm.clickCancel()
      }
    }
  }, [_vm._v("\n        取消\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bcec4738"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Popover.vue
// module id = 329
// module chunks = 1